// client/components/OntologyLegend.tsx
// Legend for Sankey graph colors and line styles

import React, { useState } from 'react';

export function OntologyLegend() {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="ontology-legend">
      <button
        className="legend-toggle"
        onClick={() => setExpanded(!expanded)}
        aria-expanded={expanded}
      >
        Legend {expanded ? '▼' : '▶'}
      </button>

      {expanded && (
        <div className="legend-content">
          <section className="legend-section">
            <h4>Node Types</h4>
            <ul>
              <li>
                <span className="legend-box" style={{ background: '#64748b' }} />
                <span>Column (source data)</span>
              </li>
              <li>
                <span className="legend-box" style={{ background: '#10b981' }} />
                <span>Term (local provider)</span>
              </li>
              <li>
                <span className="legend-box" style={{ background: '#3b82f6' }} />
                <span>Term (OLS provider)</span>
              </li>
              <li>
                <span className="legend-box" style={{ background: '#8b5cf6' }} />
                <span>Term (BioPortal provider)</span>
              </li>
              <li>
                <span className="legend-box" style={{ background: '#f59e0b' }} />
                <span>Namespace (ontology)</span>
              </li>
            </ul>
          </section>

          <section className="legend-section">
            <h4>Link Styles</h4>
            <ul>
              <li>
                <svg width="40" height="2" className="legend-line">
                  <line x1="0" y1="1" x2="40" y2="1" stroke="#10b981" strokeWidth="2" />
                </svg>
                <span>Exact Match (solid)</span>
              </li>
              <li>
                <svg width="40" height="2" className="legend-line">
                  <line
                    x1="0"
                    y1="1"
                    x2="40"
                    y2="1"
                    stroke="#10b981"
                    strokeWidth="2"
                    strokeDasharray="5,5"
                  />
                </svg>
                <span>Fuzzy Match (dashed)</span>
              </li>
              <li>
                <svg width="40" height="2" className="legend-line">
                  <line
                    x1="0"
                    y1="1"
                    x2="40"
                    y2="1"
                    stroke="#6b7280"
                    strokeWidth="2"
                    strokeDasharray="2,2"
                    opacity="0.5"
                  />
                </svg>
                <span>No Match (dotted)</span>
              </li>
            </ul>
          </section>

          <section className="legend-section">
            <h4>Link Colors</h4>
            <ul>
              <li>
                <svg width="40" height="2" className="legend-line">
                  <line x1="0" y1="1" x2="40" y2="1" stroke="#10b981" strokeWidth="2" />
                </svg>
                <span>Local (YAML)</span>
              </li>
              <li>
                <svg width="40" height="2" className="legend-line">
                  <line x1="0" y1="1" x2="40" y2="1" stroke="#3b82f6" strokeWidth="2" />
                </svg>
                <span>OLS</span>
              </li>
              <li>
                <svg width="40" height="2" className="legend-line">
                  <line x1="0" y1="1" x2="40" y2="1" stroke="#8b5cf6" strokeWidth="2" />
                </svg>
                <span>BioPortal</span>
              </li>
            </ul>
          </section>
        </div>
      )}
    </div>
  );
}
